import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';
import { tap } from 'rxjs/operators';

@Injectable()
export class AuthGuardService {
  private authService = inject(AuthService);
  private router = inject(Router);

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.authService.canActivateProtectedRoutes$.pipe(
      tap(x => {
        if (!x) {
          if (localStorage.getItem('autoLogout') === 'true') {
            localStorage.removeItem('autoLogout');
            this.router.navigate(['/landing']);
          } else {
            this.router.navigateByUrl('/landing');
          }
          return x;
        } else {
          return x;
        }
      })
    );
  }
}
